<template>
  <b-row class="my-3">
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group
        label="Sign Up"
        class="mb-2"
        label-class="head-label"
      ></b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group>
        <template slot="label">
          Enter First Name <b class="text-danger">*</b>
        </template>
        <b-form-input
          v-model="form.firstname"
          placeholder="Enter First Name"
          @keypress.native="filterAlphaNumeric"
          :state="isInvalid('firstname')"
          :maxlength="maxCharacters"
        >
        </b-form-input>
        <b-form-invalid-feedback :state="isInvalid('firstname')">
          {{ errorMessage("firstname") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group>
        <template slot="label">
          Enter Last Name <b class="text-danger">*</b>
        </template>
        <b-form-input
          v-model="form.lastname"
          placeholder="Enter Last Name"
          @keypress.native="filterAlphaNumeric"
          :state="isInvalid('lastname')"
          :maxlength="maxCharacters"
        >
        </b-form-input>
        <b-form-invalid-feedback :state="isInvalid('lastname')">
          {{ errorMessage("lastname") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group :state="isInvalid('mobile_number')">
        <template slot="label">
          Enter Mobile Number <b class="text-danger">*</b>
        </template>
        <b-input-group>
          <b-input-group-prepend is-text id="mobile-prepend"
            >+63</b-input-group-prepend
          >
          <b-form-input
            v-model="form.mobile_number"
            placeholder="Enter Mobile Number"
            maxlength="10"
            @keypress.native="filterNumeric"
            @keyup.native="trimNumber('mobile_number')"
            :state="isInvalid('mobile_number')"
            pattern="[0-9]*"
            inputmode="numeric"
          >
          </b-form-input>
        </b-input-group>
        <b-form-invalid-feedback :state="isInvalid('mobile_number')" v-html="errorMessage('mobile_number')">
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group>
        <template slot="label">
          Email Address <b class="text-danger">*</b>
        </template>
        <b-form-input
          v-model="form.email"
          placeholder="Enter Email Address"
          @keypress.native="filterAlphaNumericPunctuations"
          :state="isInvalid('email')"
          :maxlength="maxEmailCharacters"
        >
        </b-form-input>
        <b-form-invalid-feedback :state="isInvalid('email')" v-html="errorMessage('email')">
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group id="agreement-list">
        <template v-if="subdomain === 'ucoin'">
          <b-form-checkbox
            v-model="agreement.value"
            v-for="(agreement, index) in agreements"
            :key="`agreement_${index}`"
            class="mb-1"
          >
            <span v-html="agreement.text"></span>
          </b-form-checkbox>
          <div class="ml-4 mt-3">
            Privacy Notice & Cookie Notice Statements Your age and civil status will help us send you relevant news and offers from Unilever brands. Please read our <a class='text-primary' href='https://ucoin.rush.ph/ucoin/terms-of-use' target='_blank'>Terms & Conditions</a>, <a class='text-primary' href='https://www.unilevernotices.com/philippines/english/privacy-notice/notice.html' target='_blank'>Privacy Notice</a>, and <a class='text-primary' href='https://www.unilevernotices.com/philippines/english/cookie-notice/notice.html' target='_blank'>Cookie Notice</a> to understand how we use your personal data. For any questions or concerns on the use of your personal data, please contact Unilever Philippines, Inc. at <a class='text-primary' href='mailto:privacy.ph@unilever.com'>privacy.ph@unilever.com</a>, 02 8 588 8800 or toll free at 1800 105647258.
          </div>
        </template>
        <template v-else>
          <small class="text-muted">By signing up you agree to <a :href="termsAndConditionsUrl" target="_blank">Terms & Conditions</a></small>
        </template>
      </b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group class="text-center my-3">
        <b-button
          id="proceed-btn"
          variant="primary"
          pill
          class="text-white w-100"
          @click="validateFields"
          :disabled="isProceedEnabled || isLoading"
        >
          Proceed
        </b-button>
      </b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group id="auth-action">
        <span class="text-muted">Already have an account? </span>
        <router-link class="text-primary" :to="{ name: 'Login' }"
          >Login</router-link
        >
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import notification from "@/services/notification";
import "@/plugins/vue-cookies.js";

function initForm() {
  return {
    firstname: null,
    lastname: null,
    mobile_number: null,
    email: null,
  };
}

export default {
  name: "Registration",
  data() {
    return {
      maxCharacters: 50,
      maxEmailCharacters: 100,
      form: initForm(),
      agreements: [
        { value: false, text: "I confirm that I am at least 18 years old." },
        {
          value: false,
          text:
            "Sign me up to receive exciting news and exclusive offers from all Unilever brands and U-COIN, its digital rewards program.",
        },
        // {
        //   value: false,
        //   text:
        //     "Privacy Notice & Cookie Notice Statements Your age and civil status will help us send you relevant news and offers from Unilever brands. Please read our <a class='text-primary' href='https://ucoin.rush.ph/ucoin/terms-of-use' target='_blank'>Terms & Conditions</a>, <a class='text-primary' href='https://www.unilevernotices.com/philippines/english/privacy-notice/notice.html' target='_blank'>Privacy Notice</a>, and <a class='text-primary' href='https://www.unilevernotices.com/philippines/english/cookie-notice/notice.html' target='_blank'>Cookie Notice</a> to understand how we use your personal data. For any questions or concerns on the use of your personal data, please contact Unilever Philippines, Inc. at <a class='text-primary' href='mailto:privacy.ph@unilever.com'>privacy.ph@unilever.com</a>, 02 8 588 8800 or toll free at 1800 105647258.",
        // },
      ],
    };
  },
  computed: {
    ...mapGetters("auth", ["errors", "isLoading", "customerDetails"]),
    ...mapGetters("survey", ["surveyDetails"]),
    isProceedEnabled() {
      const requiredFields = Object.keys(this.form).map((field) => {
        return !!this.form[field];
      });
      const agreements = this.agreements.map((agreement) => agreement.value);
      return this.subdomain === "ucoin"
        ? requiredFields.concat(agreements).includes(false)
        : requiredFields.includes(false);
    },
    subdomain: {
      get() {
        return this.$route.params.subdomain;
      }
    },
    termsAndConditionsUrl: {
      get() {
        const environments = {
          Development: "http://estore-web-development.loyaltyco.xyz",
          Canary: "http://estore-web-canary.loyaltyco.xyz",
          Staging: "http://estore-web-staging.loyaltyco.xyz",
          Release: "http://estore-web-release.loyaltyco.xyz",
          Production: "https://estore.rush.ph"
        }
        return `${environments[process.env.VUE_APP_MODE]}/${this.$route.params.subdomain}/terms-of-use`;
      }
    },
    surveyUuid: {
      get() {
        return this.$route.params.uuid ? this.$route.params.uuid : null
      },
      set(uuid) {
        return uuid;
      }
    }
  },
  created() {
    this.$nextTick(() => {
      const element = document.getElementById("auth-container");
      if (element) element.scrollIntoView({ behavior: "smooth" });
    });
  },
  beforeDestroy() {
    this.setErrors(null);
  },
  methods: {
    ...mapMutations("auth", ["setErrors"]),
    ...mapActions("auth", ["register"]),
    isNotAlphaNumeric(input) {
      return /[^A-Za-z0-9\s]+/g.test(input); //eslint-disable-line
    },
    filterAlphaNumeric(e) {
      if (this.isNotAlphaNumeric(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
    isNotAlphaNumericPunctuations(input) {
      return /[^A-Za-z0-9 @._\s\-]+/g.test(input); //eslint-disable-line
    },
    filterAlphaNumericPunctuations(e) {
      if (this.isNotAlphaNumericPunctuations(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
    isNotNumeric(input) {
      return /[^0-9]/g.test(input);
    },
    filterNumeric(e) {
      if (this.isNotNumeric(String.fromCharCode(e.keyCode))) e.preventDefault();
    },
    isValidEmail(input) {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
      return emailRegex.test(input);
    },
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : (this.errors[field].includes('already exists') ? this.errors[field].replace(".", "") + '. Please <a class="text-blue" href="login">log in</a> instead.' : this.errors[field]);
      }
    },
    validateFields() {
      const errors = {};
      const form = this.form;
      const requiredFields = [
        "firstname",
        "lastname",
        "mobile_number",
        "email",
      ];

      requiredFields.map((field) => {
        if (!form[field])
          errors[field] = `The ${field.replace(/_/g, " ")} field is required.`;
        else if (
          (field === "firstname" || field === "lastname") &&
          form[field] &&
          this.isNotAlphaNumeric(form[field])
        )
          errors[field] = "Only alpha numeric characters are allowed.";
        else
          switch (field) {
            case "mobile_number":
              if (form[field].length < 10 || form[field].charAt(0) !== "9")
                errors[field] = "Invalid mobile number format";
              break;
            case "email":
              if (!this.isValidEmail(form[field]))
                errors[field] = "The email must be a valid email address.";
              break;
          }
      });

      this.setErrors(errors);

      if (Object.keys(errors).length === 0) this.submitRegistration();
      else notification.warning("Oops, cannot register.");
    },
    async submitRegistration() {
      const payload = this.form;
      payload["registration_channel"] = `Survey: ${this.surveyDetails.title}`;
      payload["survey_uuid"] = this.surveyUuid;
      await this.register(payload).then((unileverId) => {
        if (this.errors === null || Object.keys(this.errors).length === 0) {
          if (unileverId) {
            this.$cookies.set('UnileverID', unileverId, '30d');
            this.sendEventToAnalytics();
            this.$root.$emit('reinjectAdobeAnalytics');
          }
          this.$router.push({ name: "Nominate" });
        }
      });
    },
    trimNumber: function(ref) {
      if (this.form[ref])
        this.form[ref] = this.form[ref].replace(/\D/g, "");
    },
    sendEventToAnalytics() {
      var event = {};
      event.eventInfo = {
        type: "trackEvent",
        eventAction: "SignUp Submit",
        eventLabel: "Sign Up",
        eventValue: 1
      };
      event.category = {
        primaryCategory: "Other"
      };
      event.subcategory = "Lead";
      this.$nextTick(() => {
        this.$root.$emit('pushDigitalDataEvent', event);
      });
    }
  },
};
</script>
<style>
  .text-blue {
    color:blue;
    text-decoration: underline;
  }
</style>